module.exports = __webpack_public_path__ + "img/Myyoutube.3690149a.svg";